import { Legend } from "recharts";
import { Grid, Typography } from "@material-ui/core";
import { COLORS } from "../../../../../theme/colors";

function CustomLegend({ label }) {
  return (
    <Grid container justifyContent="center">
      <Grid item>
        <Typography variant="h4" color={COLORS.darks[0][100]}>
          {label}
        </Typography>
      </Grid>
    </Grid>
  );
}

export function getAssetDetailBarChartLegend(period) {
  if (period.name !== "H" && period.name !== "D") {
    return null;
  }

  const today = new Date();
  const label =
    period.name === "H"
      ? today.toLocaleString("en-us", { month: "short", day: "numeric" })
      : today.toLocaleString("en-us", { month: "long" });

  return <Legend key="legend" verticalAlign="top" content={<CustomLegend label={label} />} />;
}
